import { useEffect, useState } from "react";
import { useSelector } from "react-redux";
import PropTypes from "prop-types";
import CRMDiagram from "./CRMDiagram";
import CapsuleRiskMapHeader from "./CapsuleRiskMapHeader";
import CapsuleRiskMapFailureScreen from "./CapsuleRiskMapFailureScreen";
import { sceneOrientations } from "../../../constants";

function CapsuleRiskMap(props) {
    const [showCRM, setShowCRM] = useState(true);
    const [quadrantScores, setQuadrantScores] = useState({
        RA: 0,
        LA: 0,
        RP: 0,
        LP: 0,
    });

    const viewerOrientation = useSelector(
        (state) => state.CreatePlanSegReducer.viewerOrientation
    );

    // Left/Right axes are flipped when in surgery mode's AXIAL view
    const flipLeftRight =
        props.surgeryMode && viewerOrientation !== sceneOrientations.AXIAL;

    // Display error screen if capsule risk score is not available and round capsule risk scores
    useEffect(() => {
        const capsuleRiskScores =
            props.currentTreatmentPlan?.SavedData?.CapsuleRiskScores
                ?.BJUI2024RescaledData;

        // Show CRM if data is available and the user is in surgery mode or AXIAL view.
        const shouldShowCRM =
            capsuleRiskScores?.Quadrants &&
            (props.surgeryMode ||
                viewerOrientation === sceneOrientations.AXIAL);

        setShowCRM(shouldShowCRM);

        // Update quadrant scores if CRS data is valid
        if (capsuleRiskScores?.Quadrants) {
            setQuadrantScores({
                RA: Math.round(capsuleRiskScores.Quadrants.RightAnterior.Total),
                LA: Math.round(capsuleRiskScores.Quadrants.LeftAnterior.Total),
                RP: Math.round(
                    capsuleRiskScores.Quadrants.RightPosterior.Total
                ),
                LP: Math.round(capsuleRiskScores.Quadrants.LeftPosterior.Total),
            });
        }
    }, [props.currentTreatmentPlan, viewerOrientation, props.surgeryMode]);

    const containerClasses = props.surgeryMode ? "flex h-full" : "h-[36%] pt-1";
    const crmContainerClasses = props.surgeryMode
        ? "min-h-0 grow"
        : "h-[calc(100%-48px)]";

    return (
        <div className={`w-full flex-col ${containerClasses}`}>
            {!props.surgeryMode && (
                <CapsuleRiskMapHeader viewerOrientation={viewerOrientation} />
            )}
            <div className={`w-full ${crmContainerClasses}`}>
                {showCRM ? (
                    <CRMDiagram
                        quadrantScores={quadrantScores}
                        patientAnatomyModel={props.patientAnatomyModel}
                        surgeryMode={props.surgeryMode}
                        flipLeftRight={flipLeftRight}
                    />
                ) : (
                    <CapsuleRiskMapFailureScreen
                        viewerOrientation={viewerOrientation}
                    />
                )}
            </div>
            {props.surgeryMode && showCRM && (
                <div className="pr-4 text-right text-sm text-white">
                    {flipLeftRight ? "Axial View (flipped)" : "Axial View"}
                </div>
            )}
        </div>
    );
}

CapsuleRiskMap.propTypes = {
    currentTreatmentPlan: PropTypes.object,
    patientAnatomyModel: PropTypes.object,
    surgeryMode: PropTypes.bool,
};

export default CapsuleRiskMap;
